/**
 * Typed view of import.meta.env. Vite exposes only `VITE_*` vars to the client.
 */
export const env = {
  apiBase: (import.meta.env.VITE_API_BASE as string) ?? '/api',
  enableSpotcheck: (import.meta.env.VITE_FEATURE_SPOTCHECK as string) === 'true',
  enableLiteModel: (import.meta.env.VITE_FEATURE_LITE_MODEL as string) !== 'false',
  tosVersion: parseInt((import.meta.env.VITE_TOS_VERSION as string) ?? '1', 10),
};
